<template>
    <div style="background-color: #1f2d3d" :style="{ height: this.screenHeight + 'px' }">
        <Board ref="board" :rows="items" :span="3" v-cloak @init="loadConfig" @loadList="loadScheduledList" :BoardType="board_type" :roomIds="roomIds" :bedIds="bedIds" :BoardNo="board_no"></Board>
        <div
            class="message"
            :class="{ active: isHide }"
            :style="{
                width: messageWidth + 'px',
                left: messageleft + 'px',
                'min-height': `${this.minHeight}px`,
                'font-size': boardMessagefontsize + 'px'
            }"
        >
            <!-- <div class="patient_name">{{ message.title }}</div> -->
            <div v-if="surgeryInfo && surgeryInfo.id" :style="{ 'font-size': boardMessagefontsize * 0.7 + 'px' }">
                <el-row style="margin-top: 20px"> </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="24" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px"
                            >病人信息：{{ surgeryInfo.patient_name || '--' }}/{{ surgeryInfo.age || '--' }}/{{ surgeryInfo.sex || '未知' }}</label
                        ></el-col
                    >
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px"
                            >手术间：{{ surgeryInfo.dic_operating_room || '--' }}</label
                        ></el-col
                    >
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px">住院号/床号：{{ surgeryInfo.visit_no || '--' }}/{{ surgeryInfo.bed_no || '--' }}</label>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px">手术名称：{{ surgeryInfo.surgeries || '--' }}</label></el-col
                    >
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px">麻醉方式：{{ surgeryInfo.anaes_methods || '--' }}</label>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px">麻醉医生：{{ surgeryInfo.anaes_surgeon || '--' }}</label></el-col
                    >
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px">手术医生：{{ surgeryInfo.surgeon || '--' }}</label>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px">洗手护士：{{ surgeryInfo.equipment_nurse || '--' }}</label></el-col
                    >
                    <el-col :span="12" class="align-left">
                        <label style="line-height: 35px; padding-left: 20px">巡回护士：{{ surgeryInfo.circuit_nurse || '--' }}</label>
                    </el-col>
                </el-row>
            </div>
            <div class="note" v-html="messageContent"></div>
        </div>
    </div>
</template>

<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import axios from 'axios'
import Board from './Board'
import { mapGetters } from 'vuex'
import ElementUI from 'element-ui'
export default {
    name: `UnLoginBoardSchedule`,
    components: { Board },
    props: {},
    data() {
        // 获取查询日期偏移值设置
        // let offset = (this.$root.BoardScheduleQueryDateOffSet || ``).split(`,`)
        // let startOffSetDate = 0
        // let endOffSetDate = 0
        // if (offset && offset.length == 2) {
        //     startOffSetDate = parseInt(offset[0])
        //     endOffSetDate = parseInt(offset[1])
        // }
        return {
            page: 1,
            load_timer: {},
            load_message: {},
            speakFinish: {},
            all_page: 1,
            message: [],
            items: [],
            config: {},
            synth: window.speechSynthesis,
            boardConfigPageInterval: 10,
            isActive: true,
            token: sessionStorage.getItem(`token`),
            username: ``,
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            // startOffSetDate: startOffSetDate,
            // endOffSetDate: endOffSetDate,
            // queryDate: [this.$moment().add(startOffSetDate, `days`).format(`YYYY/MM/DD`), this.$moment().add(+endOffSetDate + 1, `days`).format(`YYYY/MM/DD`)],
            board_type: 1,
            board_no: this.$route.query.board_no || `1`,
            messageWidth: 800,
            messageleft: ``,
            minHeight: 500,
            boardMessagefontsize: this.$root.BoardMessagefontsize,
            boardDataHandle_PCP: this.$root.BoardDataHandle_PCP,
            noticeDatas: [],
            isHide: true,
            surgeryInfo: {},
            dic_operating_ward: this.$route.query.dic_operating_ward,
            boardNum: this.$route.query.boardNum,
            queryroomIds: this.$route.query.roomIds,
            querybedIds: this.$route.query.bedIds,
            boardScheduleConfig: this.$root.BoardScheduleConfig,
            roomIds: [],
            bedIds: []
        }
    },
    created() {
        if (this.load_timer) {
            clearInterval(this.load_timer)
        }
        if (this.loadTime_timer) {
            clearInterval(this.loadTime_timer)
        }
        this.init().then(() => {
            this.getBoardTime()
            this.getBoardConfig().then(() => {
                this.loadScheduledList().then(() => {
                    this.voiceTimer()
                    this.reseveMessage()
                    let screenWidthme = document.documentElement.clientWidth
                    let screenHeightme = document.documentElement.clientHeight
                    this.messageWidth = screenWidthme * 0.6
                    this.minHeight = screenHeightme * 0.5
                    this.messageleft = (screenWidthme * 0.5) - (this.messageWidth / 2)
                    this.timer()
                })
            })
        })
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        messageContent() {
            let content = `【紧急通知】${this.message.title}` + `</br>` + this.message.content
            return content
        }
    },
    mounted() {
        if (this.speakFinish) {
            clearInterval(this.speakFinish)
        }
        if (this.voice_timer) {
            clearInterval(this.voice_timer)
        }
    },
    methods: {
        getBoardConfig() {
            return new Promise(resolve => {
                let that = this
                let config = that.boardScheduleConfig && that.boardScheduleConfig.split(`|`) || [`0`]
                if (that.boardNum && config[0] != `0` && config[1]) {
                    let boardScheduleConfigobj = eval(
                        `(` + config[1] + `)`
                    )
                    var info = _.find(boardScheduleConfigobj, c => c.boardNum == that.boardNum)
                    if (info) {
                        that.roomIds = info.roomIds || []
                        that.bedIds = info.bedIds || []
                    }
                } else {
                    that.roomIds = that.queryroomIds && that.queryroomIds.split(`,`) || []
                    that.bedIds = that.querybedIds && that.querybedIds.split(`,`) || []
                }
                resolve(config)
            })
        },
        init() {
            if (this.newuser) {
                this.user = decodeURIComponent(window.atob(this.newuser))
            }
            return new Promise(resolve => {
                let username = this.user.split(`_`)[0]
                let password = this.user.split(`_`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    this.token = data
                    resolve(data)
                })
            })
        },
        loadConfig(config) {
            this.config = config
        },
        getBoardTime() {
            let that = this
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/Operation/BoardNotice/GetBoardTime`,
                        Object.assign(
                            {
                                headers: {
                                    Authorization: `bearer ${that.token}`
                                },
                                emulateJSON: true
                            },
                            { params: { page: that.page } } // date: that.queryDate[0], enddate: that.queryDate[1],
                        )
                    )
                    .then(response => {
                        let nowtime = response && response.other && response.other.nowTime && this.$moment(response.other.nowTime).format(`YYYY年MM月DD日 HH:mm`)
                        this.$refs.board.nowtime = nowtime
                        console.log(`this.nowtime`, nowtime)
                    })
                    .catch(e => {
                        return reject(e)
                    })
            })
        },
        loadScheduledList() {
            let that = this
            // that.queryDate = [that.$moment().add(that.startOffSetDate, `days`).format(`YYYY/MM/DD`), that.$moment().add(+(that.endOffSetDate + 1), `days`).format(`YYYY/MM/DD`)]
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `/api/Operation/BoardNotice/GetScheduledListByConfig`,
                        { page: that.page, roomIds: that.roomIds, bedIds: that.bedIds },
                        Object.assign(
                            {
                                headers: {
                                    Authorization: `bearer ${that.token}`
                                },
                                emulateJSON: true
                            }// date: that.queryDate[0], enddate: that.queryDate[1],
                        )
                    )
                    .then(response => {
                        if (response.status === 200) {
                            response.data = _.filter(response.data, d => {
                                return d.enum_surgery_status !== 10
                            })
                            let r = _.map(response.data, d => {
                                return {
                                    age: d.age || ``,
                                    birthday: d.birthday && this.$moment(d.birthday).format(`YYYY-MM-DD`) || ``,
                                    anaes_methods: d.anaes_methods || ``,
                                    anes_assistants: d.anes_assistants || ``,
                                    anes_charge_time: this.$moment(d.anes_charge_time).format(`HH:mm`) || ``,
                                    anes_charge_total: d.anes_charge_total || ``,
                                    anes_doctor: d.anes_doctor || ``,
                                    apply_time: this.$moment(d.apply_time).format(`HH:mm`) || ``,
                                    bed_no: d.bed_no || ``,
                                    biz_surgery_info_id_parent: d.biz_surgery_info_id_parent || ``,
                                    check_items: d.check_items || ``,
                                    circuit_nurse: d.circuit_nurse || ``,
                                    dic_inpatient_section: d.dic_inpatient_section || ``,
                                    dic_opearting_ward: d.dic_opearting_ward || ``,
                                    dic_operating_room: d.dic_operating_room || ``,
                                    dic_operating_room_alias: d.dic_operating_room_alias || d.dic_operating_room,
                                    dic_recovery_bed: d.dic_recovery_bed || ``,
                                    dic_recovery_ward: d.dic_recovery_ward || ``,
                                    dic_section: d.dic_section || ``,
                                    diseases: d.diseases || ``,
                                    equipment_nurse: d.equipment_nurse || ``,
                                    in_room_time: this.$moment(d.in_room_time).format(`HH:mm`) || ``,
                                    isolation_status: d.isolation_status || ``,
                                    out_room_time: (d.out_room_time && this.$moment(d.out_room_time).format(`HH:mm`)) || ``,
                                    patient_name: d.patient_name,
                                    plan_anes_assistants: (d.plan_anes_assistants && d.plan_anes_assistants[0] && d.plan_anes_assistants.map(c => c.label).join(`,`)) || ``,
                                    plan_anes_doctor: d.plan_anes_doctor && d.plan_anes_doctor.label || ``,
                                    plan_circuit_nurse: (d.plan_circuit_nurse && d.plan_circuit_nurse[0] && d.plan_circuit_nurse.map(c => c.label).join(`,`)) || ``,
                                    plan_equipment_nurse: (d.plan_equipment_nurse && d.plan_equipment_nurse[0] && d.plan_equipment_nurse.map(c => c.label).join(`,`)) || ``,
                                    plan_time: this.$moment(d.plan_time).format(`HH:mm`) || ``,
                                    plan_time_date: this.$moment(d.plan_time).format(`MM-DD`) || ``,
                                    remark: d.remark || ``,
                                    seal_date: d.seal_date || ``,
                                    sealer: d.sealer || ``,
                                    sequence: d.sequence || ``,
                                    scheduled_sequence: d.scheduled_sequence || ``,
                                    sex: d.sex || ``,
                                    surgeon: d.surgeon || ``,
                                    surgeon_assistants: d.surgeon_assistants || ``,
                                    surgeries: d.surgeries || ``,
                                    surgery_status: d.surgery_status || ``,
                                    surgery_type: d.surgery_type || ``,
                                    surgical_site: d.surgical_site || ``,
                                    visit_count: d.visit_count || ``,
                                    visit_id: d.visit_id,
                                    visit_no: d.visit_no || ``,
                                    enum_surgery_status: d.enum_surgery_status,
                                    current_key_event: d.current_key_event,
                                    key_time_summary_event: d.key_time_summary_event,
                                    current_key_eventtime: this.$moment(d.current_key_eventtime).format(`HH:mm`) || ``,
                                    his_id: d.his_id
                                }
                            })
                            this.all_page = response && response.other && response.other.all_page
                            this.page = this.page >= this.all_page || this.all_page === 0 ? 1 : this.page + 1
                            // data = this.headers.concat(r)
                            // this.items = data
                            r = _.orderBy(r, `enum_surgery_status`)
                            if (this.boardDataHandle_PCP != `0`) {
                                const str = this.boardDataHandle_PCP
                                r = this.str_to_fun(str, r)
                            }
                            this.items = r

                            this.$refs.board.pushRow = 0
                            resolve(this.items[0])
                        } else {
                            return reject(response.msg)
                        }
                    })
                    .catch(e => {
                        if (e && e.data && e.status == `600`) {
                            ElementUI.Message.error(e.data && e.data.detail)
                        } else if (e && e.data) {
                            ElementUI.Notification.error({
                                title: `错误`,
                                message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                            })
                        }
                        return reject(e)
                    })
            })
        },
        ceshi(value) {
            value = value.sort(function(a, b) {
                var x = a[`age`]
                var y = b[`age`]
                return x > y ? 1 : x < y ? -1 : 0
            })
            value = _.map(value, function(d) {
                value.age = `60`
            })
            console.log(value)
            console.log(`ceshi`)
            return value
        },
        str_to_fun(func, value) {
            return eval(func)(value)
        },
        reseveMessage() {
            let that = this
            let wsImpl = window.WebSocket || window.MozWebSocket
            window.ws = new wsImpl(this.$root.BoardIP)
            var heartCheck = {
                timeout: 60000, // 60ms
                timeoutObj: null,
                reset: function() {
                    clearTimeout(this.timeoutObj)
                    this.start()
                },
                start: function() {
                    this.timeoutObj = setTimeout(function() {
                        ws.send(`HeartBeat`)
                    }, this.timeout)
                }
            }
            ws.onmessage = function(evt) {
                heartCheck.reset()
                console.log(`=====收到消息=====`, evt.data)
                if (evt.data != `HeartBeat`) {
                    let data = JSON.parse(evt.data)
                    if (data.surgeryId) {
                        that.GetSurgeryInfo(data.surgeryId)
                    }
                    if (that.board_type !== data.board_type) {
                        return false
                    }
                    if (data.type === `BB`) {
                        if ((that.roomIds && that.roomIds.length > 0) || (that.bedIds && that.bedIds.length > 0)) {
                            if (that.roomIds && that.roomIds.length > 0 && data.roomId && _.includes(that.roomIds, data.roomId)) {
                                that.noticeDatas.push(data)
                            }
                            if (that.bedIds && that.bedIds.length > 0 && data.bedId && _.includes(that.bedIds, data.bedId)) {
                                that.noticeDatas.push(data)
                            }
                        } else {
                            that.noticeDatas.push(data)
                        }
                    }
                }
            }
            ws.onopen = function() {
                heartCheck.start()
                console.log(`connection open,连接打开`)
            }
            ws.onclose = function(e) {
                console.log(`connection closed，连接关闭`)
                console.log(`websocket 断开：` + e.code + ` ` + e.reason + ` ` + e.wasClean)
                setTimeout(function() {
                    that.reseveMessage()
                }, 5000)
            }
        },
        timer() {
            let BoardConfigSchduleScroll = this.config.BoardConfigSchduleScroll && parseInt(this.$root.BoardConfigSchduleScroll) || 0
            if (BoardConfigSchduleScroll == 0) { // 翻页
                this.load_timer = setInterval(() => {
                    if (this.isActive) {
                        this.loadScheduledList()
                    }
                }, (this.config.BoardSchduleConfigPageInterval || this.boardConfigPageInterval) * 1000)
            }
            this.loadTime_timer = setInterval(() => {
                this.getBoardTime()
            }, 10000)
        },
        voiceTimer() {
            let that = this
            console.log(`=====计时器开始执行=======`)
            this.voice_timer = setInterval(() => {
                console.log(this.noticeDatas)
                let r = this.noticeDatas[0]
                if (this.noticeDatas.length != 0 && r.board_type === that.board_type) {
                    this.voiceBroadcast()
                } else {
                    this.noticeDatas.shift()
                }
            }, 10000)
        },
        voiceBroadcast() {
            console.log(`======开始播报========`)
            let synth = window.speechSynthesis
            let that = this
            that.message = that.noticeDatas[0]
            let voices = synth.getVoices() // synth.speaking
            if (synth.speaking) {
                console.log(`上一条语音正在播放，请稍后`)
                return
            }
            that.isHide = false
            let readText = that.noticeDatas[0].title + that.noticeDatas[0].content
            let utterThis = new SpeechSynthesisUtterance(readText)

            for (let i = 0; i < voices.length; i++) {
                if (voices[i].lang == `zh-CN`) {
                    utterThis.voice = voices[i]
                    break
                }
            }
            utterThis.pitch = 1
            utterThis.rate = 0.5
            utterThis.volume = 1
            utterThis.onerror = function(event) {
                console.log(`请点击开启语音按钮`)
            }

            for (let i = 0; i < that.message.play_time; i++) {
                synth.speak(utterThis)
            }

            that.speakFinish = setInterval(function() {
                this.speaking = synth.speaking
                console.log(`=====正在播报${this.speaking}=======`)
                if (!synth.speaking) {
                    console.log(`播报结束`)
                    that.isHide = true
                    that.noticeDatas.shift()
                    console.log(`speakFinish`)
                    console.log(that.speakFinish)
                    clearInterval(that.speakFinish)
                    that.speakFinish = null
                }
            }, 1000)
        },
        GetSurgeryInfo(surgeryId) {
            // 获取当前手术和消息信息
            let that = this
            axios
                .get(
                    `/api/Operation/Home/Get?id=${surgeryId}`,
                    Object.assign(
                        {
                            headers: {
                                Authorization: `bearer ${this.token}`
                            },
                            emulateJSON: true
                        }

                    )
                )
                .then(response => {
                    if (response.status === 200) {
                        that.surgeryInfo = response.data
                    }
                })
        }
    },
    destroyed() {
        clearInterval(this.load_timer)
        clearInterval(this.loadTime_timer)
        clearInterval(this.speakFinish)
        clearInterval(this.voiceTimer)
    },
    watch: {}
}
</script>

<style scoped>
[v-cloak] {
    display: none !important;
}
.background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #1f2d3d;
}
.message {
    position: fixed;
    top: 20%;
    left: 50%;
    width: 800px;
    color: #ffffff;
    background-image: linear-gradient(#ee0262, #650133);
    z-index: 999;
    border-radius: 10px;
    font-size: 64px;
}
.patient_name,
.note {
    height: 50%;
    line-height: 150px;
}
.active {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Board/UnLoginBoardSchedule.vue